import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IPollGeneral } from '../../../../models/poll.model';
import * as clientSelectors from '../../../../ngrx/reducers/client.reducer';
import { Observable } from 'rxjs/Observable';
import { IClientConfig } from '../../../../models/client.model';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-poll-message',
  templateUrl: 'poll-message.html'
})

export class PollMessageComponent implements OnInit {

  public clientConfig$: Observable<IClientConfig>;

  @Input('general') public general: IPollGeneral;
  @Input('language') public language: string;
  @Output('changeView') public changeView: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private store: Store <{}>,
  ) { }

  ngOnInit() {
    this.clientConfig$ = this.store.select(clientSelectors.getClientConfig);
   }

  public changeToQuestions(){
    this.changeView.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/pages/poll/components/poll-message/poll-message.ts